// extracted by mini-css-extract-plugin
export var borderBottom = "Standard-module--border-bottom--cc1e5";
export var borderLeft = "Standard-module--border-left--ae674";
export var borderRight = "Standard-module--border-right--1100b";
export var borderTop = "Standard-module--border-top--65919";
export var textAlignCenter = "Standard-module--text-align-center--edccc";
export var textAlignLeft = "Standard-module--text-align-left--f48b8";
export var textAlignRight = "Standard-module--text-align-right--559c0";